module.exports = __webpack_public_path__ + "static/bg-audl-a1149a66654b50940e9ca4395c8ce04c.webp";